import { render, staticRenderFns } from "./PageJoin.vue?vue&type=template&id=53361061&scoped=true"
import script from "./PageJoin.vue?vue&type=script&lang=js"
export * from "./PageJoin.vue?vue&type=script&lang=js"
import style0 from "./PageJoin.vue?vue&type=style&index=0&id=53361061&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53361061",
  null
  
)

export default component.exports